import axios from 'axios';
import Cookies from 'js-cookie';
import { goRiceUrl } from '../constant/siteConstants';
import { logOut } from '../utils/logOut';

// Tokeni almak için bir yardımcı fonksiyon
const getToken = () => Cookies.get('token');
const getRefreshToken = () => localStorage.getItem('refreshToken') || '';

// Yeni bir Axios instance oluştur
const api = axios.create({
    baseURL: `${goRiceUrl}/api`,
    headers: {
        'Content-Type': 'application/json',
        'token': getToken()
    }
});

// Token'i isteğe ekleyen bir request interceptor
api.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.headers['token'] = token;
        }
        return config;
    },
    error => Promise.reject(error) // İstek hatası varsa olduğu gibi döndür
);

// Token yenileme fonksiyonu (401 Unauthorized durumunda kullanılacak)
const refreshToken = async () => {
    try {
        const response = await axios.post(`${goRiceUrl}/api/refresh-token`, {
            token: getRefreshToken()
        });
        if (response.data?.token) {
            localStorage.setItem('token', response.data.token);
            return response.data.token;
        }
    } catch (error) {
        console.error("Token yenileme başarısız.");
        return null;
    }
};
let isHandling401Error = false;

const handleError = error => {
    // Eğer response yoksa (network hatası vb.)
    if (!error.response) {
        return Promise.reject({
            message: 'Sunucuya bağlanılamıyor'
        });
    }

    const { status, data } = error.response;

    // 401 Unauthorized hatası
    if (status === 401) {
        if (!isHandling401Error) {
            isHandling401Error = true;
            logOut(() => { }, false);
        }
        return Promise.reject({
            message: 'Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.'
        });
    }

    // 403 Forbidden hatası
    if (status === 403) {
        return Promise.reject({
            message: 'Bu işlem için yetkiniz yok'
        });
    }

    // 404 Not Found hatası
    if (status === 404) {
        const apiUrl = error.config?.url || error.request?.responseURL || 'API';
        return Promise.reject({
            message: `İstek ucu "${apiUrl}" bulunamadı`
        });
    }

    // 500 ve diğer hatalar
    return Promise.reject({
        message: data?.error || data?.message || 'Bir hata oluştu'
    });
};
// Response interceptor: Token yenileme işlemi ve diğer hata yönetimi
api.interceptors.response.use(
    response => response, // Başarılı yanıtları olduğu gibi döndür
    error => handleError(error) // Diğer durumlar için hata yönetimi
);

export default api;